import React from 'react';
import PropTypes from 'prop-types';
import CustomReactMarkdown from '../../MarkdownRenderers/CustomReactMarkdown';


const ProductAddOnIneligible = function ProductAddOnIneligibleComponent({
  addOn,
}) {
  const {
    status: {
      message,
    },
  } = addOn;

  return (
    <CustomReactMarkdown
      className="product-addon__ineligible"
      linkMeta={['allowIcon']}
      source={message}
    />
  );
};

ProductAddOnIneligible.propTypes = {
  addOn: PropTypes.shape({
    status: PropTypes.shape({
      message: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ProductAddOnIneligible;
